import { AdPlacement } from "@/components/ads/AdPlacement";
import {
  SciBreadcrumb,
  SciExplainer,
  SciHeader,
  SciPage,
} from "@/lib/science/sci-ui";
import { m } from "@/paraglide/messages";
import { PhredCalc } from "../components/PhredCalc";

export function CalculatorPage() {
  return (
    <SciPage>
      <SciBreadcrumb
        homeLabel={m.sci_breadcrumb_home()}
        toolName={m.phred_tool_name()}
        toolPath="/phred-quality-score"
      />
      <SciHeader title={m.phred_h1()} intro={m.phred_intro()} />

      <PhredCalc />

      <SciExplainer
        howToTitle={m.sci_howto_title()}
        howTo={m.phred_howto()}
        examplesTitle={m.sci_examples_title()}
        examples={[m.phred_ex1(), m.phred_ex2(), m.phred_ex3()]}
        faqTitle={m.sci_faq_title()}
        faqs={[
          { q: m.phred_faq_q1(), a: m.phred_faq_a1() },
          { q: m.phred_faq_q2(), a: m.phred_faq_a2() },
          { q: m.phred_faq_q3(), a: m.phred_faq_a3() },
          { q: m.phred_faq_q4(), a: m.phred_faq_a4() },
        ]}
      />

      <AdPlacement className="mt-10" />
    </SciPage>
  );
}
